import { connect } from 'react-redux';
import { getLineItems, getPrice } from '../../../selectors/index';
import { getDiscount } from '../../../selectors/discount';
import { selectDiscount } from '../../../actions/discount';
import PriceBar from './PriceBar';

const mapStateToProps = state => {
  const discountInfo = getDiscount(state);
  const priceInfo = getPrice(state, discountInfo);
  const subTotal = Math.max(priceInfo.basePrice - priceInfo.discount, 0);

  return {
    baseprice: priceInfo.basePrice,
    discount: Math.min(priceInfo.discount, priceInfo.basePrice),
    subtotal: subTotal,
    tax: priceInfo.tax,
    taxes: priceInfo.taxes,
    provinceState: state.bookingLocation.selectedLocation.provinceState,
    total: subTotal + priceInfo.tax - state.giftCard.total_amount,
    lineItemsList: getLineItems(state, discountInfo) || '',
    discountInfo: discountInfo || '',
    giftCardsTotal: state.giftCard.total_amount,
    currencySymbol: state.bookingLocation.selectedLocation.currency_symbol
  };
};

const mapDispatchToProps = dispatch => ({
  updateSelectedDiscount: discount => dispatch(selectDiscount(discount))
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceBar);
